module.exports = __webpack_public_path__ + "img/consult_info2.d18b77ca.png";